module.exports = __webpack_public_path__ + "static/media/aws.bed0d1d3.png";